var _style, _path, _path2, _path3, _path4, _polygon, _polygon2, _path5, _path6, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvenstarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 610.4 516.3",
    style: {
      enableBackground: "new 0 0 610.4 516.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:#38C3E2;}\n\t.st5{fill:#E8E8E8;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.0024,
    y1: -14.7499,
    x2: 77.8741,
    y2: 237.2059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#60DDEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1842,
    style: {
      stopColor: "#60D7EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4245,
    style: {
      stopColor: "#60C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6959,
    style: {
      stopColor: "#61ACF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#6187FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6185FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.4,98.4c-19.6,45.5-54.9,84.2-100,105.3c-45.3,21.2-97.8,25.1-145.6,10.2c-26.8-8.4-51.8-22.4-72.8-41 c38.1,21.2,82.7,29.2,125.9,23c43.9-6.3,85-27.4,115.8-59.4c17.8-18.5,32-40.3,41.6-64c9.1,4.3,17.5,9.9,25.3,16.3 c2.5,2.1,5,4.2,7.3,6.5C316.4,96.1,318.2,97.4,318.4,98.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.0535,
    y1: -14.7057,
    x2: 77.9251,
    y2: 237.2501
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#60DDEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1842,
    style: {
      stopColor: "#60D7EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4245,
    style: {
      stopColor: "#60C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6959,
    style: {
      stopColor: "#61ACF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#6187FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6185FF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.1,184.8c2.6-0.6,2.8-0.2,2.8-2.9c0-1.6,0.1-3.3,0.2-4.9c0.2-3.8,0.8-7.5,1.6-11.2 c1.5-7,4.1-13.8,7.5-20.1c6.8-12.3,17-22.7,29.2-29.6c12.6-7.1,27.2-10.4,41.6-9.5c8,0.5,15.9,2.3,23.4,5.3 c1.5,0.6,3.1,1.8,4.7,2.1c1.7,0.3,1.3,0.5,2.6-0.9c0.8-0.8,1.6-1.6,2.3-2.5c2.6-3,4.8-6.4,7.1-9.7c4.6-6.8,7.9-14.2,9.9-22.1 c0.5-1.9,0.9-3.8,1.2-5.8c0.3-1.5,1.2-4.5,0.8-5.9c-0.7-2.2-9-3.3-11.5-3.8c-16.5-3.6-33.6-3.9-50.2-0.8 c-28.7,5.3-52.9,20.8-72.5,42.1c-20.5,22.3-31,54.7-30.1,84.6C112.5,188.3,122.4,186.9,132.1,184.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.261,
    y1: 51.2703,
    x2: 154.1327,
    y2: 303.2261
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#60DDEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1842,
    style: {
      stopColor: "#60D7EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4245,
    style: {
      stopColor: "#60C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6959,
    style: {
      stopColor: "#61ACF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#6187FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6185FF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M219.2,275.1c-1.8-6.1-2.4-10.9-1.9-16.9c-2.3,0.2-4.5,0.3-6.9,0.3c-22.3,0-42.4-11-56.2-26.5 c-4.5,0.5-9,0.8-13.6,1c-2.7,0.1-5.4,0.2-8.1,0.2c-6.2,0-12.2-0.3-18.2-0.8c-0.2,0-0.5,0-0.7-0.1c-0.5,0-1-0.1-1.4-0.1 c18.5,46.3,63.8,79,116.7,79c8.1,0,16.1-0.8,23.8-2.3C237,304.2,224.1,291.9,219.2,275.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.5473,
    y1: 25.5459,
    x2: 124.4189,
    y2: 277.5017
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#60DDEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1842,
    style: {
      stopColor: "#60D7EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4245,
    style: {
      stopColor: "#60C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6959,
    style: {
      stopColor: "#61ACF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#6187FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6185FF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M370.8,37.5c-25,7.2-40.9,31.8-37.4,57.5c-2.9-7.9-18.1-20-23.4-23.4c-5.2-3.4-28-15.4-34-14.3 c4.9-1.4,12.7-5.6,15.1-7.2c5.4-3.7,10-8.4,13.7-13.8c3.5-5.2,10.5-18.1,8.8-36.3C321.1,24.9,345,40.5,370.8,37.5z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-28.2,237.9 -28.2,237.9 -28.2,237.9 -28.2,237.9 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "87.5,150.2 87.5,150.2 87.5,150.2 87.5,150.2 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-0.1,295c0,0.1,0.1,0.3,0.1,0.4C0,295.3-0.1,295.1-0.1,295z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.1,411.2C93.1,411.2,93.1,411.2,93.1,411.2L93.1,411.2C93.1,411.2,93.1,411.2,93.1,411.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M326.7,225.5h-18.3l1.7-12.5h50.7l-1.7,12.5h-18.3l-7.2,51.6h-14.1L326.7,225.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M380.4,208.7l-4.3,30.4h0.2c0.4-0.8,1-1.7,1.9-2.5c0.8-0.8,1.8-1.6,2.9-2.3c1.1-0.7,2.4-1.2,3.8-1.6 c1.4-0.4,3-0.6,4.6-0.6c3.4,0,6.2,0.5,8.1,1.6c2,1.1,3.4,2.5,4.3,4.4c0.9,1.9,1.4,4.1,1.4,6.6c0.1,2.5-0.1,5.3-0.5,8.2l-3.3,24.2 H386l3-21.5c0.2-1.3,0.3-2.6,0.5-3.9c0.1-1.4,0-2.6-0.3-3.8c-0.3-1.1-0.9-2.1-1.7-2.8c-0.8-0.7-2.1-1.1-3.9-1.1s-3.2,0.3-4.4,0.9 s-2.1,1.5-2.8,2.5c-0.7,1.1-1.3,2.2-1.6,3.6c-0.4,1.3-0.6,2.7-0.8,4.2l-3.1,21.9h-13.6l9.6-68.4H380.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M451.8,269.5c-2.5,2.8-5.6,4.9-9.1,6.4c-3.5,1.5-7.1,2.3-10.6,2.3c-3.4,0-6.5-0.5-9.3-1.6 c-2.8-1.1-5.2-2.6-7.1-4.7c-1.9-2-3.3-4.4-4.2-7.3c-0.9-2.8-1.1-6-0.6-9.5c0.5-3.5,1.6-6.7,3.2-9.5c1.7-2.8,3.7-5.3,6.2-7.3 c2.5-2,5.3-3.6,8.4-4.7c3.1-1.1,6.4-1.6,9.8-1.6c3.1,0,5.9,0.5,8.3,1.6c2.4,1.1,4.4,2.6,5.9,4.7c1.5,2,2.5,4.4,3.1,7.3 c0.6,2.8,0.6,6,0.1,9.5l-0.6,4.3h-31.5c0.2,2.6,1.1,4.7,2.7,6.2c1.6,1.5,3.7,2.3,6.4,2.3c2.2,0,4.2-0.5,5.8-1.5 c1.7-1,3.2-2.3,4.6-3.8L451.8,269.5z M443,250.1c0.4-2.3-0.1-4.3-1.4-5.9c-1.3-1.6-3.2-2.4-5.7-2.4c-1.5,0-2.9,0.2-4.1,0.7 c-1.2,0.5-2.3,1.1-3.2,1.9c-0.9,0.8-1.7,1.6-2.3,2.6c-0.6,1-1,2-1.3,3.1H443z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M324.5,299.6h65.1l-2.7,19.5h-44l-2.6,17.9H382l-2.7,19.5h-41.6L335,376h46.5l-2.7,19.5h-67.6L324.5,299.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M392.7,329.6h21.9l10.3,44.7h0.3l21.8-44.7h20.5l-35.2,65.8h-21.5L392.7,329.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M526.8,384.1c-3.8,4.2-8.3,7.4-13.6,9.6c-5.3,2.3-10.6,3.4-15.9,3.4c-5.1,0-9.7-0.8-13.9-2.4 c-4.2-1.6-7.8-3.9-10.6-7c-2.8-3-4.9-6.7-6.2-10.9c-1.3-4.2-1.6-9-0.9-14.2c0.7-5.2,2.3-10,4.8-14.2c2.5-4.2,5.6-7.9,9.3-10.9 c3.7-3,7.9-5.4,12.6-7c4.7-1.6,9.6-2.4,14.6-2.4c4.7,0,8.8,0.8,12.5,2.4c3.6,1.6,6.5,4,8.8,7c2.3,3,3.8,6.7,4.7,10.9 c0.9,4.2,0.9,9,0.2,14.2l-0.9,6.4h-47.1c0.3,3.9,1.6,7,4,9.3c2.4,2.3,5.6,3.5,9.5,3.5c3.3,0,6.3-0.7,8.7-2.2 c2.5-1.5,4.8-3.4,6.8-5.8L526.8,384.1z M513.6,355.1c0.5-3.4-0.2-6.4-2.2-8.8c-2-2.4-4.8-3.7-8.5-3.7c-2.3,0-4.3,0.4-6.1,1.1 c-1.8,0.7-3.4,1.6-4.7,2.8c-1.4,1.1-2.5,2.4-3.4,3.9c-0.9,1.5-1.5,3-1.9,4.7H513.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M549.9,329.6h19.5l-1.2,8.9h0.3c0.8-1.3,1.9-2.5,3.2-3.8c1.4-1.3,2.9-2.4,4.6-3.4c1.7-1,3.7-1.8,5.8-2.4 c2.2-0.6,4.5-0.9,6.9-0.9c5.1,0,9.2,0.8,12.2,2.4c3,1.6,5.1,3.8,6.5,6.6c1.4,2.8,2.1,6.1,2.2,9.9c0.1,3.8-0.2,7.9-0.8,12.3l-5,36.3 h-20.3l4.5-32.2c0.3-1.9,0.5-3.9,0.7-5.9c0.2-2,0-3.9-0.4-5.6c-0.5-1.7-1.3-3.1-2.6-4.2c-1.3-1.1-3.2-1.6-5.8-1.6 c-2.6,0-4.8,0.5-6.6,1.4c-1.8,0.9-3.2,2.2-4.3,3.8c-1.1,1.6-1.9,3.4-2.4,5.4c-0.5,2-0.9,4.1-1.2,6.2l-4.6,32.8h-20.3L549.9,329.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M367.9,441.4c-1.4-2.2-3.6-3.8-6.4-4.8c-2.8-1-5.5-1.6-8.1-1.6c-1.5,0-3.2,0.2-4.9,0.5 c-1.7,0.4-3.3,0.9-4.8,1.7c-1.5,0.8-2.8,1.8-3.9,3c-1.1,1.3-1.8,2.8-2,4.6c-0.3,2.2,0.1,4,1.2,5.4c1,1.4,2.5,2.6,4.5,3.5 c1.9,0.9,4.2,1.8,6.8,2.5c2.6,0.7,5.2,1.5,7.8,2.4c2.6,0.9,5.2,2,7.7,3.2c2.5,1.3,4.6,2.9,6.4,4.8c1.8,1.9,3.1,4.4,4,7.3 c0.9,2.9,1,6.5,0.3,10.6c-0.7,5.3-2.4,10-4.9,14c-2.6,4-5.7,7.3-9.5,9.9c-3.7,2.6-7.9,4.6-12.6,5.8c-4.7,1.3-9.5,1.9-14.4,1.9 c-6.2,0-11.9-0.9-16.9-2.8c-5.1-1.9-9.6-5-13.7-9.2l17.5-16.5c1.8,2.9,4.2,5.1,7.2,6.7c3,1.6,6.3,2.4,9.8,2.4 c1.7,0,3.5-0.2,5.3-0.6c1.8-0.4,3.5-1,5-1.8c1.5-0.8,2.8-1.8,3.9-3.1c1-1.3,1.7-2.8,2-4.5c0.5-2.9-0.3-5.2-2.4-6.8 c-2-1.7-4.6-3.1-7.8-4.3c-3.2-1.2-6.6-2.3-10.3-3.5c-3.7-1.2-7.1-2.8-10.2-4.7c-3.1-2-5.5-4.6-7.2-7.9c-1.8-3.3-2.3-7.5-1.6-12.9 c0.7-5.1,2.4-9.7,4.9-13.5c2.6-3.9,5.8-7.1,9.5-9.8c3.8-2.6,8-4.6,12.6-5.9c4.6-1.3,9.3-2,14-2c5.4,0,10.5,0.8,15.4,2.3 c4.8,1.5,9,4.1,12.5,7.7L367.9,441.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M437.2,464.3h-17.9l-3.1,21.9c-0.3,1.8-0.4,3.5-0.4,4.9c0,1.5,0.2,2.8,0.7,3.9c0.5,1.1,1.4,1.9,2.6,2.5 c1.2,0.6,2.9,0.9,5.1,0.9c1.1,0,2.5-0.1,4.3-0.3c1.8-0.2,3.1-0.7,4.1-1.6l-2.3,16.9c-2.3,0.8-4.8,1.4-7.2,1.6 c-2.5,0.3-4.9,0.4-7.2,0.4c-3.4,0-6.5-0.4-9.3-1.1c-2.8-0.7-5.2-1.9-7.1-3.5c-1.9-1.6-3.3-3.6-4.2-6.2c-0.9-2.5-1.1-5.6-0.6-9.2 l4.5-31.3h-13l2.3-16.3h13l2.7-19.5h20.3l-2.7,19.5h17.9L437.2,464.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M485.7,505.6h-0.3c-2.7,3.5-6,6-10,7.6c-4,1.5-8,2.3-12.2,2.3c-3.1,0-6-0.4-8.7-1.3c-2.7-0.9-5-2.1-7-3.9 c-1.9-1.7-3.4-3.8-4.3-6.4c-0.9-2.5-1.1-5.5-0.7-8.8c0.8-5.7,3-10.1,6.4-13.2c3.5-3.1,7.6-5.4,12.3-6.9c4.7-1.5,9.7-2.4,14.9-2.6 c5.2-0.3,9.9-0.4,14.2-0.4c0.5-3.6-0.5-6.5-2.7-8.6c-2.3-2.1-5.1-3.2-8.7-3.2c-3.3,0-6.5,0.7-9.4,2.1c-2.9,1.4-5.7,3.3-8.2,5.8 l-9.2-11.1c4.2-3.5,9-6.2,14.3-7.9c5.3-1.8,10.6-2.6,16.1-2.6c6,0,10.8,0.7,14.4,2.2c3.7,1.5,6.4,3.7,8.3,6.6 c1.9,2.9,3,6.4,3.3,10.6s0.1,9.1-0.7,14.6l-4.6,33.5h-18.7L485.7,505.6z M483.5,485c-1.5,0-3.5,0.1-5.8,0.2 c-2.3,0.1-4.6,0.5-6.8,1.2c-2.2,0.6-4.2,1.6-5.8,2.8c-1.7,1.3-2.6,3-2.9,5.3c-0.2,1.3,0,2.3,0.4,3.2c0.5,0.9,1.1,1.6,1.9,2.2 c0.8,0.6,1.8,1.1,2.9,1.4c1.1,0.3,2.2,0.4,3.3,0.4c2,0,4-0.3,5.9-0.8c1.9-0.5,3.7-1.3,5.3-2.3c1.6-1,2.9-2.3,4-3.8 c1.1-1.5,1.8-3.3,2-5.4l0.5-4.3H483.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M528,448h20.3l-1.5,10.6h0.3c2.7-4.1,5.7-7.1,8.9-9.1c3.3-2,7.1-3,11.6-3c1.2,0,2.3,0,3.5,0.1 c1.2,0.1,2.3,0.3,3.3,0.5l-2.6,18.6c-1.4-0.5-2.8-0.8-4.2-1c-1.4-0.2-2.8-0.3-4.3-0.3c-3.9,0-7,0.5-9.5,1.6 c-2.4,1.1-4.4,2.6-5.8,4.5c-1.4,1.9-2.6,4.3-3.3,7c-0.8,2.7-1.4,5.7-1.8,8.9l-3.8,27.5h-20.3L528,448z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvenstarLogo);
export default __webpack_public_path__ + "static/media/evenstar-logo.730649d326b4e07be9edef5c06e7a9aa.svg";
export { ForwardRef as ReactComponent };